import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { ButtonGroup, FormGroup, IconButton, List, ListItem, ListItemIcon, ListItemText, Stack, TextField, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';

export default function ExtensionCompDialog(pros) {
  const {open, setOpen, action} = pros

  const [nome, setNome] = React.useState('');
  const [atr, setAtr] = React.useState([]);
  const [tag, setTag] = React.useState('<Extension />');

  const handleClose = () => {
    if( action) action( montaComponente() );
    setOpen(false);
  };

  function handleAddAtr(){
    const nm = document.getElementById('id-atr-nome').value;
    const vl = document.getElementById('id-atr-value').value;
    let arr = [...atr];
    arr.push({
        atributo: nm,
        valor: vl
    });
    setAtr( arr );
    document.getElementById('id-atr-nome').value = '';
    document.getElementById('id-atr-value').value ='';
  }
  function montaComponente(){
    let tag = "<Componente nome='"+nome+"' ";
    for(let x in atr){
        const a = atr[x];
        tag += " "+a.atributo+"='"+a.valor+"'";
    }
    tag +=" >"+nome+"</Componente>"
    return tag;
  }
  function handleDelete(item){
    let arr = [];
    for(let x in atr){
        const a = atr[x];
        if( a.atributo === item.atributo)continue;
        arr.push(a)
    }
    setAtr(arr);
  }
  return (    
      <Dialog        
        fullWidth
        maxWidth="md"        
        open={open}
        onClose={handleClose}
      >
        <DialogTitle>Adicionar Extensão</DialogTitle>
        <IconButton
                aria-label="close"
                onClick={() => setOpen(false)}
                sx={(theme) => ({
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: theme.palette.grey[500],
                })}
            >
                <CloseIcon />
            </IconButton>
        <DialogContent sx={{minHeight:'300px'}}>
            <FormGroup >
            <TextField id="id-comp-name" label="Nome do componente" variant="outlined" 
                fullWidth value={nome} onChange={(e)=> setNome(e.target.value)}
                sx={{marginBottom:1}}
            />
            <Box component="section" sx={{ p: 2, border: '1px solid grey' }}>
                <TextField id="id-atr-nome" label="Atributo" variant="outlined" />
                <TextField id="id-atr-value" label="Valor" variant="outlined" />
                <IconButton
                    aria-label="close"
                    onClick={handleAddAtr}
                    color='primary'
                >
                    <AddIcon />
                </IconButton>
                <List>
                    { atr && atr.map((item, id)=>
                    <ListItem key={"id-"+id}>
                        <ListItemIcon onClick={() => handleDelete(item)}
                            sx={{cursor:'pointer'}}
                        >
                            <DeleteIcon />
                        </ListItemIcon>
                        <ListItemText primary={item.atributo +"="+item.valor} />
                    </ListItem>    
                    )}
                </List>
            </Box>
            
            <Typography variant="h6" gutterBottom sx={{marginTop:1, border: '1px solid grey'}}>
                {montaComponente()}
            </Typography>
            </FormGroup>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Ok</Button>
        </DialogActions>
      </Dialog>
  );
}